import * as React from "react";
import { useState } from "react";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import Login from "./comp/Login.js";
import Logon from "./comp/Logon.js";
import RecuperaPassword from "./comp/RecuperaPassword";
import ReimpostaPassword from "./comp/ReimpostaPassword";
import Abilita2fa from "./comp/Abilita2fa";

import UtentiLista from "./comp/UtentiLista";
import UtentiModifica from "./comp/UtentiModifica";

import ClientiLista from "./comp/ClientiLista";
import ClientiModifica from "./comp/ClientiModifica";

import SezioniLista from "./comp/SezioniLista";
import SezioniModifica from "./comp/SezioniModifica";

import VersioniLista from "./comp/VersioniLista";

import DomandeLista from "./comp/DomandeLista";
import DomandeModifica from "./comp/DomandeModifica";

import Layout from "./comp/layout/Layout";

import HomeQuestionari from "./comp/questionario/HomeQuestionari";
import QuestionarioModifica from "./comp/questionario/QuestionarioModifica";
import QuestionarioDomanda from "./comp/questionario/QuestionarioDomanda";
import QuestionarioPdf from "./comp/questionario/QuestionarioPdf";
import { isAdminGlobale } from "./inc/inc.js";
import ExportDomande from "./comp/ExportDomande.js"

function App() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#ccc",
      },
    },
  });

  const [testoTitolo, setTestoTitolo] = useState("");

  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <CssBaseline />

        <Routes>
          <Route path={process.env.PUBLIC_URL + "/login"} element={<Login />} />
          <Route path={process.env.PUBLIC_URL + "/registrati"} element={<Logon />} />
          <Route path={process.env.PUBLIC_URL + "/recupera-password"} element={<RecuperaPassword />} />
          <Route path={process.env.PUBLIC_URL + "/reimposta-password"} element={<ReimpostaPassword />} />

          <Route
            path={process.env.PUBLIC_URL + "/questionario/pdf/:id/:tipo/:token/:filtriJson?"}
            element={
              <QuestionarioPdf
                testoTitolo={testoTitolo}
                setTestoTitolo={setTestoTitolo}
              />
            }
          />

          <Route path={process.env.PUBLIC_URL + "/exportDomande"} element={<ExportDomande />} />

          <Route path={process.env.PUBLIC_URL + "/"} element={<Layout testoTitolo={testoTitolo} />}>
            <Route
              path={process.env.PUBLIC_URL + "/"}
              element={
                isAdminGlobale() ? (
                  <DomandeLista
                    testoTitolo={testoTitolo}
                    setTestoTitolo={setTestoTitolo}
                  />
                ) : (
                  <HomeQuestionari
                    testoTitolo={testoTitolo}
                    setTestoTitolo={setTestoTitolo}
                  />
                )
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/questionario-nuovo"}
              element={
                <QuestionarioModifica
                  nuovo={true}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/questionario/:id"}
              element={
                <QuestionarioModifica
                  nuovo={false}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/questionario/domanda/:id?"}
              element={
                <QuestionarioDomanda
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route path="abilita2fa" element={<Abilita2fa />} />
            <Route
              path={process.env.PUBLIC_URL + "/utenti"}
              element={
                <UtentiLista
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/utente-nuovo"}
              element={
                <UtentiModifica
                  nuovo={true}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/utente/:id"}
              element={
                <UtentiModifica
                  nuovo={false}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/utente-modifica"}
              element={
                <UtentiModifica
                  nuovo={false}
                  utenteLoggato={true}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/domande"}
              element={
                <DomandeLista
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/domanda-nuovo"}
              element={
                <DomandeModifica
                  nuovo={true}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/domanda/:id"}
              element={
                <DomandeModifica
                  nuovo={false}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/clienti"}
              element={
                <ClientiLista
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/cliente-nuovo"}
              element={
                <ClientiModifica
                  nuovo={true}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/cliente/:id"}
              element={
                <ClientiModifica
                  nuovo={false}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/sezioni"}
              element={
                <SezioniLista
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/sezione-nuovo"}
              element={
                <SezioniModifica
                  nuovo={true}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
            <Route
              path={process.env.PUBLIC_URL + "/sezione/:id"}
              element={
                <SezioniModifica
                  nuovo={false}
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />

            <Route
              path={process.env.PUBLIC_URL + "/versioni"}
              element={
                <VersioniLista
                  testoTitolo={testoTitolo}
                  setTestoTitolo={setTestoTitolo}
                />
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
